export default function PjCard09() {
    return (
        <div
            style={{
                position: "relative",
                zIndex: "10",
                width: "20em",
                maxWidth: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            <img
                src="/assets/projects/bp/invitation/Invitation%20-%20Welcom%201.png"
                alt="B-day Party gallery"
                loading="lazy"
                style={{
                    display: "block",
                    width: "100%",
                    height: "26em",
                    objectFit: "contain",
                    borderRadius: "2em",
                }}
            />
        </div>
    );
}
